import { ComponentRendering, RouteData } from '@sitecore-jss/sitecore-jss-nextjs'
import { createContext, useContext, useState } from 'react'
import { NavigationProps } from './Navigation/_interface'
import { SettingsProps } from 'components/ADFSettings'

type Props = {
  rendering: RouteData | null
  children: React.ReactNode
}

export type SharedContextProps = {
  drawers: Map<string, boolean>
  showInServiceNames: boolean
  updateDrawers: () => void
}

export const SharedContext = createContext<SharedContextProps>({
  drawers: new Map<string, boolean>(),
  showInServiceNames: false,
  updateDrawers: () => {
    /**/
  },
})

export default function SharedContextProvider({ children, rendering }: Props) {
  const [showInServiceNames] = useState(() => {
    const settings = rendering?.placeholders?.["headless-footer"]?.find(x => (x as ComponentRendering)?.componentName == "ADFSettings") as SettingsProps | null | undefined
    const showInServiceNames = settings?.fields?.data?.datasource?.showInServiceTitle?.field?.value == true
    return showInServiceNames
  })
  const [refresh, setRefresh] = useState(false)
  const [drawers, _setDrawers] = useState(new Map<string, boolean>())

  const ctx = {
    drawers,
    showInServiceNames,
    updateDrawers: () => {
      setRefresh(!refresh)
    },
  }

  return <SharedContext.Provider value={ctx}>{children}</SharedContext.Provider>
}

export function useSharedContext() {
  return useContext(SharedContext)
}
